import { useTenantedQueryKey } from '@cotera/client/app/hooks/use-tenanted-query-key';
import { useTenantedClient } from '@cotera/client/app/stores/org';
import { Assert } from '@cotera/utilities';
import { useSuspenseQuery } from '@tanstack/react-query';

export const useStackFramesAtPrefix = (key: string) => {
  const client = useTenantedClient();
  const tenantedKey = useTenantedQueryKey(['stack-frames-stats', key]);

  const { data } = useSuspenseQuery({
    queryKey: tenantedKey,
    queryFn: async () => {
      return Assert.assertOk(
        await client.atc.runGroup.atPrefix({ prefix: key })
      );
    },
  });

  return data;
};
